/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, useMemo} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useAuth} from '../core/Auth'
import {Logout} from '../Logout'
import {Link, useNavigate} from 'react-router-dom'
import {getUserByToken, login, registerPage, checkEmail} from '../core/_requests'
import 'react-phone-number-input/style.css'
import MuiPhoneNumber from 'material-ui-phone-number'
import {GoogleLogin, GoogleLogout} from 'react-google-login'
import {gapi} from 'gapi-script'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
}

export function LandingPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [profile, setProfile] = useState<any>([])
  const {saveAuth, setCurrentUser} = useAuth()
  const [Cselect, setSelect] = useState()
  const onSelect = (code: any) => setSelect(code)
  const [country, setCountry] = useState<any>([])
  const [onlyCountries, setOnlyCountries] = useState<any>([])
  const [countryCode, setCountryCode] = useState<string>('+91')
  const [google, setGoogle] = useState(false)
  const [googleData, setgoogleData] = useState(false)
  const [accemail, setAccEmail] = useState(false)
  const [invaliduid, setInvaliduid] = useState<any>()
  const [displaymessage, setDisplayMessage] = useState<string>()
  const [googleValues, setGoogleValues] = useState({
    name: '',
    contact: '',
    email: '',
    password: '',
    changepassword: '',
  })
  const location = useLocation()
  const {Uemail, googleStatus, Uname} = location.state || ''

  function googleCheck() {
    if (Uname != 'undefined' && Uemail != 'undefined') {
      if (googleStatus == 1) {
        setDisplayMessage("Sorry! We couldn't find an account registered with Vitta.Please Signup")
        setgoogleData(true)
        formik.setValues({
          name: Uname,
          email: Uemail,
          password: '',
          changepassword: '',
          contactNo: '',
        })
      } else {
        setgoogleData(false)
      }
    }
  }
  const initialValues = {
    name: '',
    email: '',
    password: '',
    changepassword: '',
    contactNo: '',
  }
  useEffect(() => {
    googleCheck()
  }, [googleValues])

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const registrationSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^[A-Za-z ]+$/, 'Name should contain only alphabetic characters')
      .min(3, 'Minimum 3 characters')
      .max(50, 'Maximum 50 characters')
      .required('Name Required'),
    email: Yup.string()
      .email('Wrong email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Email Required'),
    contactNo: Yup.string()
      .matches(/^\+91\s\d{5}-\d{5}$/, 'Invalid Format')
      .required('Contact Number Required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await registerPage(values.name, values.email, '0', values.contactNo)
        if (auth.api_token === undefined || auth.api_token === '') {
          setgoogleData(false)
          setStatus('User already exists with the same email ID or phone number.')
          setLoading(false)
        } else {
          localStorage.setItem('api_token', auth.api_token)
          localStorage.setItem('account_verified', auth.account_verified)
          setSuccess(true)
        }
      } catch (error: any) {
        saveAuth(undefined)
        setStatus('Unable to Process')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  async function getUID() {
    const uid = localStorage.getItem('uid')
    if (uid !== 'null' || '') {
      let data = {
        temp_property_request_uuid: uid,
      }

      let result = await axios.post(`${LOCAL_URL}/invitationDetails`, data)

      if (result) {
        formik.setValues({
          name: '',
          email: result.data.email_id,
          password: '',
          changepassword: '',
          contactNo: '',
        })
      } else {
        setInvaliduid('INVALID LINK')
      }
    }
  }

  return (
    <>
      {success ? (
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <img
              className='w-50 h-25 p-8'
              src={toAbsoluteUrl('/media/svg/undraw/register_success.svg')}
              alt='Registration success'
            />
          </div>
          <p className='text-muted fs-3 font-weight-bold d-flex flex-column justify-content-center align-items-center' style={{fontWeight:"600"}}>
            <span>We have sent the login credential to your email.</span>
            <span>Please use it to login.</span>
          </p>
          
          <Link to='/auth' className='btn btn-sm btn-primary me-3 mt-2'>
            Go to login
          </Link>
        </div>
      ) : (
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_signin_form'
          onSubmit={formik.handleSubmit}
        >
          {googleData ? (
            <div className='text-center mb-11 alert alert-danger'>{displaymessage}</div>
          ) : (
            ''
          )}

          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}
          <div className='text-center mb-11'>
            <h1 className='text-dark fw-bolder mb-3'>Registration</h1>
          </div>

          <div className='fv-row mb-3'>
            <div className='error'> {invaliduid} </div>
          </div>

          <div className='fv-row mb-3'>
            {/* begin::Form group name */}
            <label className='form-label fw-bolder text-dark fs-6'>Name</label>
            {/* {googleData ? <>
        <input  type='text'
          autoComplete='off'  className='form-control bg-transparent'   {...formik.getFieldProps('name') } value={Uname}
            />
             
        </>: */}
            <>
              <input
                placeholder='Name'
                type='text'
                autoComplete='off'
                {...formik.getFieldProps('name')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.name && formik.errors.name,
                  },
                  {
                    'is-valid': formik.touched.name && !formik.errors.name,
                  }
                )}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.name}</span>
                  </div>
                </div>
              )}
            </>

            {/* }  */}
          </div>

          {/* begin::Form group */}
          <div className='fv-row mb-3'>
            <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
            {/* {googleData ? 
<>
<input  className='form-control bg-transparent' value={Uemail} />

</>: */}
            <>
              <input
                placeholder='Email'
                {...formik.getFieldProps('email')}
                className={clsx(
                  'form-control bg-transparent',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
                type='email'
                name='email'
                autoComplete='off'
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </>
            {/* }  */}
          </div>
          {/* end::Form group */}

          <div className='fv-row mb-8'>
            <label className='form-label fw-bolder text-dark fs-6'>Contact Number</label>
            <MuiPhoneNumber
              defaultCountry={'in'}
              {...formik.getFieldProps('contactNo')}
              onChange={(value) => formik.setFieldValue('contactNo', value)}
              className={clsx(
                'form-control bg-transparent',
                {'is-invalid': formik.touched.contactNo && formik.errors.contactNo},
                {'is-valid': formik.touched.contactNo && !formik.errors.contactNo}
              )}
            />

            {formik.touched.contactNo && formik.errors.contactNo && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.contactNo}</span>
                </div>
              </div>
            )}
          </div>

          {/* 


      {/* begin::Form group */}
          <div className='text-center'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-lg btn-primary w-100  mb-3 rounded hover-scale'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className='indicator-label'>Submit</span>}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
          {/* end::Form group */}
        </form>
      )}
    </>
  )
}
